export const Button = props => {
    return <>
        <button type="button" onClick={props.onClick}>Click Me!</button>
    </>
}